<!--
<div class="mat-typography" >
  <div class="col-sm-12 successTitle">
    <h2>{{data.userType.titleOne}}</h2>
  </div>
</div>
<mat-dialog-actions align="end" *ngIf="data.userType.access == 'teamdelete'" class="action_sec">
<button mat-raised-button style="background-color: #AD1A00;color: #fff;" (click)="DeletBtnClick()"  [mat-dialog-close]="true" >Yes</button>
<button mat-raised-button style="font-weight: 400;" [mat-dialog-close]="true">No</button>
</mat-dialog-actions>

<mat-dialog-actions align="end" *ngIf="data.userType.access == 'logout'" class="action_sec">
<button mat-raised-button style="background-color: #AD1A00;color: #fff;" (click)="logoutClick()"  [mat-dialog-close]="true" >Yes</button>
<button mat-raised-button style="font-weight: 400;" [mat-dialog-close]="true">No</button>
</mat-dialog-actions> -->
<button style="outline: none;" *ngIf="data.userType.access != 'restric'" class="close-button forgetPass"
  [mat-dialog-close]="true" (click)="onClickClose()" id="closeBtn">
  <img src="../../../assets/icons/x-button.svg">
</button>
<div class="confir_sec">
  <div class="row">
    <div class="col-sm-12" *ngIf="data.userType.access != 'replaceCart' && data.userType.access != 'replaceProducts'">
      <img height="82px" width="82px" style="float: left;" [defaultImage]="defaultImage" [lazyLoad]="data.userType.imgPath">
    </div>

    <div class="col-sm-12 successTitle">
      <h2>{{data.userType.titleOne}}</h2>
      <p>{{data.userType.text}}</p>
    </div>
  </div>
  <mat-dialog-actions style=" gap: 30px; margin: 0; padding: 0;" *ngIf="data.userType.access == 'teamdelete'"
    class="action_sec">
    <button class="btn_yes" mat-raised-button style="" (click)="DeletBtnClick()" [mat-dialog-close]="true">Yes</button>
    <button class="btn_no" mat-raised-button style="" [mat-dialog-close]="true">No</button>
  </mat-dialog-actions>


  <mat-dialog-actions style=" gap: 27px; margin: 0; padding: 0;" *ngIf="data.userType.access == 'replaceCart'"
    class="action_sec">
    <button class="btn_yes" mat-raised-button style="" (click)="replaceCartItems()" [mat-dialog-close]="true">Yes</button>
    <button class="btn_no" mat-raised-button style="" [mat-dialog-close]="true">No</button>
  </mat-dialog-actions>

  <mat-dialog-actions style=" gap: 27px; margin: 0; padding: 0;" *ngIf="data.userType.access == 'replaceProducts'"
    class="action_sec">
    <button class="btn_yes" mat-raised-button style="" (click)="replaceProducts()" [mat-dialog-close]="true">Yes</button>
    <button class="btn_no" mat-raised-button style="" (click)="replaceProductsCancel()" [mat-dialog-close]="true">No</button>
  </mat-dialog-actions>

  <mat-dialog-actions style=" gap: 30px; margin: 0; padding: 0;" *ngIf="data.userType.access == 'orderSuccess'"
    class="action_sec">
    <!-- <button class="btn_yes" mat-raised-button style="" (click)="logoutClick()" [mat-dialog-close]="true">Yes</button> -->
    <button class="btn_no" mat-raised-button style="width: 100% !important;" (click)="logoutClick()" [mat-dialog-close]="true">Ok</button>
  </mat-dialog-actions>

  <mat-dialog-actions style=" gap: 30px; margin: 0; padding: 0;" *ngIf="data.userType.access == 'item'"
    class="action_sec">
    <!-- <button class="btn_yes" mat-raised-button style="" (click)="logoutClick()" [mat-dialog-close]="true">Yes</button> -->
    <button class="btn_no" mat-raised-button style="width: 100% !important;" [mat-dialog-close]="true">Ok</button>
  </mat-dialog-actions>

  
</div>